import { ClassProvider, Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';

export function provideMatPaginatorIntl(): ClassProvider {
  return {
    provide: MatPaginatorIntl,
    useClass: LocalizedMatPaginatorIntl,
  };
}

@Injectable()
export class LocalizedMatPaginatorIntl extends MatPaginatorIntl {
  override itemsPerPageLabel = $localize`Items per page`;
  override nextPageLabel = $localize`Next page`;
  override previousPageLabel = $localize`Previous page`;

  override getRangeLabel = (
    page: number,
    pageSize: number,
    length: number,
  ): string => {
    let totalPages = 1;
    let currentPage = 1;
    if (!(length === 0 || pageSize === 0)) {
      totalPages = Math.ceil(length / pageSize);
      currentPage = page + 1;
    }

    return $localize`:@@paginator-range-label:Page ${currentPage} of ${totalPages}`;
  };
}
